// extracted by mini-css-extract-plugin
export default {"filter_wrapper":"styles-module__filter_wrapper--loV0S"};